const urlRegex = /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;
const digitsRegex = /\d+/g;
const underscoreRegex = /_/g;

export type SnakeToKebabCase<S extends string> = S extends `${infer P1}_${infer P2}${infer P3}`
  ? `${P1}-${P2}${SnakeToKebabCase<P3>}`
  : S;

export function snakeToKebabCase<T extends string>(input: T): SnakeToKebabCase<T> {
  return input.replace(underscoreRegex, '-') as SnakeToKebabCase<T>;
}

export function searchSpecialSymbols(text: string): boolean {
  return /^(?!Special symbols).+/g.test(text);
}

export function capitalizeWord(word: string): string {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

export function getDigitFromString(string: string): string {
  return string.match(digitsRegex)?.join('') ?? '';
}

export function snakeToArrayOfStrings(text: string): string[] {
  return text.split('_');
}

export function replaceUrlsWithHtmlLinks(text: string): string {
  return text.replace(
    urlRegex,
    '<a href="$1" rel="nofollow noreferrer noopener" target="_blank">$1</a>',
  );
}
